import Vue from 'vue';
import VueI18n from 'vue-i18n';
import japanese from '@/lang/ja.js';
import english from '@/lang/en.js';

Vue.use(VueI18n)
const messages = {
  'ja': japanese,
  'en': english, 
}

const pluralizationRules = {
  'ja': customRule,
  'en': customRule,
}

function customRule(choice, choicesLength, orgRule) {
  if(Number.isInteger(choice) && choice < choicesLength - 1) return choice
  else return choicesLength - 1
}

const i18n = new VueI18n({
  locale: process.env.MIX_LOCALE, // set locale
  fallbackLocale: 'ja',
  silentTranslationWarn: true,
  messages, // set locale messages
  pluralizationRules,
})
export default i18n